<template>
  <a-layout-content :style="{ padding: '10px' }">
    <a-spin size="large" :spinning="pageLoading">
      <div style="min-height: 100vh">
        <a-tooltip title="Geri">
          <button class="btn-back">
            <img
              src="../../../assets/imgs/return.png"
              class="back-img"
              @click="goBack"
            />
          </button>
        </a-tooltip>

        <problem-header v-if="problem" :problem="problem"></problem-header>

        <a-row type="flex" :gutter="24" v-if="problem">
          <a-col span="24">
            <a-row type="flex" :gutter="24">
              <a-col
                :span="15"
                style="height: max-content"
                class="image__container"
              >
                <conditional-media
                  :filesList="problem.files"
                ></conditional-media>

                <p class="username" v-if="problem.addUser">
                  {{
                    problem.addUser.firstName +
                    " " +
                    problem.addUser.lastName +
                    " " +
                    problem.addUser.fatherName
                  }}
                </p>

                <p class="title" style="overflow-wrap: anywhere;">{{ problem.title }}</p>

                <p class="date-txt" v-if="problem">
                  {{ problem.dateStr }}
                  <a-icon type="clock-circle" style="margin-right: 7px" />
                </p>

                <div
                  v-if="getCategoriesOfProblem.length > 0"
                  style="
                    display: flex;
                    align-items: flex-start;
                    margin: 0 6px 10px;
                  "
                >
                  <p style="margin-right: 15px; margin-bottom: 0">Müraciətin təsnifatı:</p>

                  <div
                    style="
                      margin-right: 15px;
                      display: flex;
                      width: 100%;
                      flex-wrap: wrap;
                       white-space: break-spaces;
                    "
                  >
                    <a-tag
                      v-for="category in getCategoriesOfProblem"
                      :key="category.uuid"
                      color="#108ee9"
                      style="
                        display: flex;
                        align-items: center;
                        max-width: 100%;
                        white-space: break-spaces;
                        margin-bottom: 5px;
                      "
                    >
                      {{ category.name }}
                      {{
                        category.parent
                          ? `(${category.parent.name.toLowerCase()})`
                          : ""
                      }}
                    </a-tag>
                  </div>
                </div>
              </a-col>

              <a-col :span="9" class="operation-panel image__container">
                <div class="detailed">
                  <a-button
                    v-if="
                      privilege.selectParentOffice === 'REQUIRED' ||
                      privilege.selectParentOffice === 'OPTIONAL'
                    "
                    @click="addOfficeDetail(null)"
                    style="margin-right: 10px"
                  >
                Qurum əlavə et
                  </a-button>

                  <a-button
                    v-if="privilege.selectRepresentation"
                    style="margin-right: 10px"
                    :class="{ colorflashing: !problem.representation }"
                    @click="representationModalVisibility = true"
                    >Məsul əməkdaş təyin et</a-button
                  >

                  <!--  <a-button
                    v-if="currentStep.canIdentifyStreet"
                    style="margin-right: 10px;"
                    :class="{ colorflashing: !problem.street }"
                    @click="addrModalVis = true"
                    >Ünvanı müəyyənləşdir</a-button
                  > -->

                  <a-button
                    type="default"
                    @click="showDetailed(problem)"
                    style="text-align: right"
                    >Ətraflı</a-button
                  >
                </div>

                <div v-if="problem.execStructures.length > 0">
                  <div
                    style="
                      background-color: #e6f7ff;
                      border: 1px solid #91d5ff;
                      padding: 10px;
                      border-radius: 5px;
                    "
                  >
                    <!-- {{'İcraçı təşkilatlar: ' +
                      problem.execStructures.map((item) => item.name + (!item.isApproved? ' (təsdiq olunmayib)':'') ).join(', ')}}  -->
                   Qurumlar:
                    <div v-for="x in problem.execStructures" :key="x.id">
                     {{
                        x.name + (!x.isApproved ? " (təsdiq olunmayib)" : "")
                      }} 

                       <a-button
                       style="float:right"
                        v-if="
                        currentStep.canApproveParentOffice&&
                          !x.isApproved &&
                          (privilege.selectParentOffice === 'REQUIRED' ||
                            privilege.selectParentOffice === 'OPTIONAL')
                        "
                        size="small"
                        @click="addOfficeDetail(x)"
                        >Təsdiq et</a-button 
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="last-op"
                  v-if="
                    problem &&
                    problem.lastOperation &&
                    problem.lastOperation.opUser &&
                    !privilege.workWithDetails
                  "
                >
                  <p>Əvvəlki əməliyyat</p>
                  <p>
                    {{ getOperationText(problem.lastOperation) }}
                    <a-tooltip
                      v-if="problem.lastOperation.note"
                      :title="problem.lastOperation.note"
                    >
                      <a-icon type="message" />
                    </a-tooltip>

                    <a-button
                      style="
                        float: right;
                        top: 15px;
                        background-color: #fff;
                        color: black;
                        border-radius: 5px;
                      "
                      size="small"
                      v-if="problem.lastOperation.files.length > 0"
                      @click="showMediaFiles(problem.lastOperation.files)"
                    >
                      Fayllara bax
                    </a-button>
                  </p>
                </div>

         

              
           


         

  

  

                  <div style="text-align:center">
                    <h3>{{problem.assigningForComment.fromStructure.name}}</h3>
                  <p>{{problem.assigningForComment.dateCreated}}</p>
                  </div>

                <div v-if="privilege && !privilege.workWithDetails">
                  <p>Rəy</p>
                  <a-textarea
                 
                    :autoSize="{ minRows: 2, maxRows: 6 }"
                    v-model="problem.noteField"
                  ></a-textarea>
                </div>

                <div
                  v-if="
                    privilege &&
                    !privilege.workWithDetails &&
                    currentStep.fileAnswer
                  "
                  style="overflow: auto"
                >
                  <p>Fayllar</p>
                  <my-file-upload
                    ref="fileUpload"
                    :filesList="fileList"
                    pkey="problem"
                    :max="5"
                    @upload-change="handleUploadChange"
                  ></my-file-upload>
                </div>

                <div
                  v-if="privilege && !privilege.workWithDetails"
                  class="actions-container"
                >

                    <a-button
                    
                   
                    @click="handleOpSubmit(true)"
                    :style="{ backgroundColor: '#999' }"
                    >İmtina et
                  </a-button>
                  <a-button
                 
                    @click="handleOpSubmit(false)"
                    :style="{ backgroundColor:  '#999'}"
                    >Təsdiq et
                  </a-button>
              
                </div>
              </a-col>
            </a-row>
          </a-col>
        </a-row>

        <not-found-problem v-if="resNotFound"></not-found-problem>

        <detail-modal
          :visible="modalVisible"
          :problemOb="problem"
          @afterClose="handleModalClose"
        ></detail-modal>

        <address-modal
          :visible="addrModalVis"
          :problem="problem"
          @after-close="handleAddrModalClose"
          @success="handleAddrSuccess"
        ></address-modal>
        <AddOfficeModal
        :selectedPOffice="selectedPOffice"
          :problem="problem"
          :privilege="privilege"
          :visible="opDetailVisibility"
           @afterClose="handleAddOffModalClose"
        />

        <!--Representation modal-->
        <representation-modal
          :visible="representationModalVisibility"
          :problem="problem"
          @afterClose="handleRepAfterClose"
          @change="handleRepChange"
        ></representation-modal>
      </div>
    </a-spin>
  </a-layout-content>
</template>

<script>
import { URL, apiCall } from "@/utils/api";
// import { mapGetters, mapMutations, mapActions } from "vuex";
import mixin from "@/mixins/index";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";
import moment from "moment";
import DetailModal from "@/components/pages/Modals/DetailModal/index";
import AddOfficeModal from "@/components/pages/Modals/AddOfficeModal/index";
import AddressModal from "@/components/pages/Modals/AddressModal/index";
import CitizenList from "@/components/partials/CitizenList/index";
import NotFoundProblem from "@/components/partials/NotFoundProblem";
import RepresentationModal from "@/components/pages/Modals/RepresentationModal/index";
import ProblemHeader from "@/components/partials/ProblemHeader/index";
import MyFileUpload from "@/components/partials/MyFileUpload";


export default {
  name: "ActionDetails",
  mixins: [mixin],
  components: {
    "conditional-media": ConditionalMedia,
    VNodes: { functional: true, render: (_h, ctx) => ctx.props.vnodes },
    "detail-modal": DetailModal,
    "citizen-list": CitizenList,
    "not-found-problem": NotFoundProblem,
    "representation-modal": RepresentationModal,

    "problem-header": ProblemHeader,
    "address-modal": AddressModal,
    "my-file-upload": MyFileUpload,
    AddOfficeModal,
   
  },
  data() {
    return {
      opDetailVisibility: false,
      submitLoading: false,
      statuses: [],
      representationModalVisibility: false,
      buttons: [],
      problem: null,
      representations: [],
      offices: [],
      officesFiltered: [],
      executors: [],
      avtiveKey: null,
      selectedExecutiveId: null,
      initialOfficeIds: [],
      selectedRepresentationId: null,
      selectedOfficeId: null,
      selectedExecutorUUID: null,
      executeLastDate: null,
      privilege: null,
      fileList: [],
      files: [],
      selectedAction: null,
      modalVisible: false,
      selectedDetOffice: null,
      myconfirmVis: false,
      resNotFound: false,
      initialOffices: [],
      willDeletedOffices: [],
      addrModalVis: false,
      actionsForNewOff: null,
      filterExecutives: [],
      executives: [],
      selectedPOffice: null,
    };
  },

  watch: {
    problem: {
      immediate: true,
      handler: function (_newVal) {
      
      },
    },
  },
  computed: {
    problemGenOfficeDetails: function () {
      return (this.privilege.selectParentOffice === "REQUIRED" ||
        this.privilege.selectParentOffice === "OPTIONAL") &&
        !this.privilege.workWithDetails
        ? this.problem.officeDetails
        : [];
    },
    getCategoriesOfProblem: function () {
      const categories = this.problem ? this.problem.categories : [];
      return categories;
    },
  },
  methods: {
    moment,
    goBack() {
      this.$router.push("/main");
    },

    handleOfficeAddClose() {
    
      this.selectedPOffice = null;
    },
    handleAddOffModalClose() {
      this.opDetailVisibility = false;
    },
    disabledDate(current) {
      return current && current < moment().endOf("day");
    },
    handlePhoneKeyDown(e) {
      if (isNaN(Number(e.key))) e.preventDefault();
    },
    searchExecs(key) {
      const regex = new RegExp(key, "i");
      this.filterExecutives = this.executives.filter((item) =>
        regex.test(item.name.toLowerCase())
      );
    },
    searchOffices(key) {
      const regex = new RegExp(key, "i");
      this.officesFiltered = this.offices.filter((item) =>
        regex.test(item.name.toLowerCase())
      );
    },
    handleUploadChange( fileList) {
      this.fileList = fileList;
     
    },
    addOfficeDetail(parenToffice) {
      console.log({parenToffice});
      this.selectedPOffice = parenToffice;
      this.opDetailVisibility = true;
      /*       let newOfficeDetail = {
        clientId: this.problem.officeDetails.length + 1,
        office: null,
        noteField: null,
        isNew: true,
        fileList: [],
      };

      const newOfficeDetails = [newOfficeDetail, ...this.problem.officeDetails];
      this.problem = {
        ...this.problem,
        officeDetails: newOfficeDetails,
      }; */

      // this.problem.officeDetails.push(newOfficeDetail);
    },
    handleRepChange(rep) {
      this.$set(this.problem, "representation", rep);
      this.representationModalVisibility = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    checkIfDisabled(office) {
      return (
        !this.currentStep.uncheckOffice &&
        this.initialOfficeIds.indexOf(office.id) !== -1
      );
    },
    handleMyConfirmClose() {
      this.myconfirmVis = false;
    },
    getFilteredOffices() {
      this.getExecutorStructures().then((response) => {
        if (!response.data.error) {
          // evvelceden secilmis ust idareleri cixardiram ki secmesin
          this.offices =
            this.privilege.selectParentOffice === "REQUIRED" ||
            this.privilege.selectParentOffice === "OPTIONAL"
              ? response.data.data.entities.filter(
                  (item) => this.initialOfficeIds.indexOf(item.id) === -1
                )
              : response.data.data.entities;
          this.officesFiltered = this.offices;
        }
      });
    },
    handleParentOfficeChange(val, officeDetail) {
      if (
        this.problem.officeDetails.filter(
          (item) => item.selectedParentOfficeId === val
        ).length > 1
      ) {
        this.$message.error("Bu qurum artıq seçilib");
        this.$set(officeDetail, "selectedParentOfficeId", null);
        return;
      }
      if (this.privilege.selectParentOffice) {
        officeDetail.parentOffice = { id: val };
      }
    },
    showConfirm(sendData, detailOffice, content) {
      const dataToSend = sendData;
      const message = this.$message;
      const destroyAll = this.$destroyAll;
      const set = this.$set;
      const operationdetail = this.$refs.operationdetail;
      const { problem, privilege } = this;
      this.$confirm({
        title: content,
        //content: content,
        okText: "Bəli",
        okType: "primary",
        cancelText: "Xeyr",
        onOk() {
          return new Promise((resolve, reject) => {
            apiCall({
              url:
                URL[process.env.NODE_ENV].service_api +
                "problems/" +
                problem.id,
              method: "PUT",
              data: dataToSend,
            })
              .then((response) => {
                if (!response.data.error) {
                  if (privilege.workWithDetails) {
                    destroyAll();
                    set(
                      problem,
                      "officeDetails",
                      problem.officeDetails.filter(
                        (item) => item.id !== detailOffice.id
                      )
                    );
                    operationdetail.removeSent(detailOffice.parentOffice.id);
                    message.info("Müraciət göndərildi.");
                    if (problem.officeDetails.length > 0) return;
                  } else {
                    message.info("Müraciət göndərildi.");
                  }

                  setTimeout(() => {
                    window.location.href = "/main";
                  }, 1000);
                } else {
                  message.error(response.data.error.message);
                  destroyAll();
                }
              })
              .catch((_err) => {
                destroyAll();
              });
          }).catch((err) => {
            // eslint-disable-next-line no-console
         
          });
        },
        onCancel() {
        
        },
      });
    },
    // handleUploadChange(fileList, officeDetail) {
    //   if (officeDetail) {
    //     officeDetail.fileList = fileList;
    //     return;
    //   }
    //   this.fileList = fileList;
    // },
  

   
    handleOpSubmit(isCancel) {
     if (
        (!this.problem.noteField || this.problem.noteField.trim().length == 0)
      ) {
        this.$message.error("Qeyd mütləq daxil edilməlidir.");
        return;
      }
      console.log(this.fileList,'list');
          return new Promise((resolve, reject) => {
            apiCall({
              url:
                URL[process.env.NODE_ENV].service_api +
                `problems/${this.problem.id}/forCommentAssignings`,
              method: "POST",
              data:{
                comment:this.problem.noteField,
                isCancelled:isCancel,
                files:this.fileList
              }
            })
              .then((response) => {
                if (!response.data.error) {
                  window.location.href = "/main";
                } else message.error(response.data.error.message);
              })
              .catch((_err) => {
               
                destroyAll();
              });
          }).catch();
        },
    handleRemove(officeDetail) {
      const newOfficeDetails = [...this.problem.officeDetails].filter(
        (item) => item.clientId !== officeDetail.clientId
      );
    
      this.problem = {
        ...this.problem,
        officeDetails: newOfficeDetails,
      };
    },
    getProblemDetails() {
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          "problems/" +
          this.$route.params.id,
        method: "GET",
        params: {
          key:
            window.location.pathname.split("/").length === 0
              ? ""
              : window.location.pathname.split("/")[1],
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.problem = response.data.data;
            console.log(this.problem,'fasdfdsafdsafsa');
            this.privilege = this.problem.privilege;
            this.problem.officeDetails.forEach((officeDetail) => {
              this.$set(officeDetail, "clientId", null);
              if (
                (this.privilege.selectParentOffice === "REQUIRED" ||
                  this.privilege.selectParentOffice === "OPTIONAL") &&
                officeDetail.parentOffice
              ) {
                this.$set(
                  officeDetail,
                  "selectedParentOfficeId",
                  officeDetail.parentOffice.id
                );
              }
              officeDetail.fileList = [];
              if (this.privilege.workWithFeedbackResult) {
                officeDetail.restartCount = 0;
                officeDetail.assestments.forEach((as) => {
                  if (as.startAgain) {
                    officeDetail.restartCount++;
                  }
                });
              }
              if (officeDetail.category)
                this.$set(
                  officeDetail,
                  "selectedCategoryUUID",
                  officeDetail.category.uuid
                );
            });
            if (this.privilege.showCitizenList) {
              this.getCitizenAppeals({
                problemId: this.problem.id,
                detailed: false,
              });
            }
            if (
              this.privilege.selectParentOffice === "REQUIRED" ||
              this.privilege.selectParentOffice === "OPTIONAL"
            ) {
              this.getExecutorStructures().then((response) => {
                if (!response.data.error) {
                  this.offices = response.data.data.entities;
                  this.officesFiltered = this.offices;
                }
              });
            }
            if (
              this.privilege.selectSubOffice === "REQUIRED" ||
              this.privilege.selectSubOffice === "OPTIONAL"
            ) {
              this.getSubOffices().then((response) => {
                if (!response.data.error) {
                  this.offices = response.data.data.entities;
                }
              });
            }

            if (this.privilege.selectExecutive) {
              this.getExecutives();
            }
            if (!this.privilege.workWithDetails) {
              this.getActions(this.problem.id, null).then(
                (response) => (this.buttons = response.data.data)
              );
            }
          } else if (response.data.error.code === 1080) {
            this.$message.error(response.data.error.message);
            this.resNotFound = true;
          }
          this.pageLoading = false;
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
        
          this.pageLoading = false;
        });
    },
    handleAddrSuccess() {
      this.problem.street = {};
      this.addrModalVis = false;
    },
    showDetailed(_detail) {
      this.modalVisible = true;
    },
    handleModalClose() {
      this.modalVisible = false;
    },
    handleAddrModalClose() {
      this.addrModalVis = false;
    },
    sendBack() {
      const message = this.$message;
      const destroyAll = this.$destroyAll;
      const problem = this.problem;
      this.$confirm({
        // title: content,
        //content: "Dəyişiklik yadda saxlanılsın?",
        okText: "Bəli",
        okType: "primary",
        cancelText: "Xeyr",
        onOk() {
          return new Promise((resolve, reject) => {
            apiCall({
              url:
                URL[process.env.NODE_ENV].service_api +
                `problems/${problem.id}/sendBack`,
              method: "POST",
            })
              .then((response) => {
                if (!response.data.error) {
                  window.location.href = "/main";
                } else message.error(response.data.error.message);
              })
              .catch((_err) => {
                destroyAll();
              });
          }).catch();
        },
      });
    },
  },
  async created() {
    this.pageLoading = true;
    this.getProblemDetails();

    console.log(this.problem,'fsdfds');
  },
};
</script>

<style lang="scss" src="./index.scss"></style>
